import React from 'react';
// import Header from '../components/Header';
import Hero from '../components/Hero';
import WhyHireWithWorkdeskVA from '../components/WhyHire';
import GetToKnowWorkDeskVA from '../components/GetToKnow';
import CountUpStats from '../components/CountUpStats';
import HireService from '../components/Hireservice';
import Casestudy from '../components/Casestudy';
import OurTechnologies from '../components/ourtechnologies';
import Clientlogos from '../components/logosloop';
import WorkProcess from '../components/Workprocess';
// import Footer from '../components/Footer';
// import OurTeam from '../components/Ourteam';

import Testimonial from '../components/Testimonial';
import Form from '../components/form';
import Blog from '../components/Blog';


function Home() {
  return (
    <div>
      <Hero />
 
      <WhyHireWithWorkdeskVA />
      <CountUpStats />
      <GetToKnowWorkDeskVA />
      <Casestudy />
      <OurTechnologies />
      {/* <ScrollVelocity texts={['React Bits', 'Scroll Down']} velocity={100} className="custom-scroll-text" /> */}
      <WorkProcess />
      <Blog/>
      <Clientlogos />
      <HireService />
      <Testimonial />
      {/* <OurTeam /> */}
      <Form/>
      
    </div>
  );
}

export default Home;
